


import React, { useState, useEffect, useRef } from "react";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";

import OrderStatistics from "./components/OrderStatistics";
import BookingBar from "./components/bookingbar";
import ConfirmationModal from "../../admin-pages/services/components/confirmation";
import { jwtDecode } from "jwt-decode";
import Card from "./components/card";

const VendorDashboard = () => {
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;



  //booking Start

  const bookingheaders = [
    "Booking ID",
    "Booked Date",
    "Booked Category",
    "Customer Name",
    "Scheduled Date & Time",
    "Status",
    "Action",
  ];




  const [recentLeadsData, setRecentLeadsData] = useState();

  useEffect(() => {
     const token = localStorage.getItem("tokenfirst");
            if (!token) {
                console.error("No token found.");
                return;
            }
        
            const decodedToken = jwtDecode(token);
            console.log(decodedToken); 
        
            const vendorId = decodedToken.email; 
    fetch(`${baseUrl}/bookingvendor/bookingbyId/${vendorId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {

        const sortedLeads = data.bookingsData.sort((a, b) => {
          return new Date(b.createdDate) - new Date(a.createdDate);
        });
        setRecentLeadsData(sortedLeads);
        console.log(sortedLeads, "jkjkjk")
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }, []);



  // services


  const [data, setData] = useState({});

    const [showModal, setShowModal] = useState(false);
    const [currentService, setCurrentService] = useState(null);
    const [refreshData, setRefreshData] = useState(false);  


  useEffect(() => {
    const token = localStorage.getItem("tokenfirst");

    fetch(`${baseUrl}/addservices/getservices`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data.result, "Fetched Data");
        setData(data);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }, [refreshData]);

  const headers = [
    "Service ID",
    "Service Name",
    "Category",
    "Price",
    "Basic Fare",
    "Verify Status",
    "Action",
  ];
  const handleStatusChange = (subId, currentStatus) => {
    setCurrentService({ subId, currentStatus });
    setShowModal(true);
};

const confirmStatusChange = async () => {
    const { subId, currentStatus } = currentService;
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    try {
        const response = await fetch(`${baseUrl}/services/serviceconfirmation`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subId: subId,
                servicestatus: newStatus,
            }),
        });

        const result = await response.json();

        if (result) {
            // setData((prevData) =>
            //     prevData.map((item) => ({
            //         ...item,
            //         serviceDetails: item.serviceDetails.map((service) =>
            //             service.subId === subId
            //                 ? { ...service, servicestatus: newStatus }
            //                 : service
            //         ),
            //     }))
            // );
            setRefreshData((prev) => !prev);

        } 
    } catch (error) {
        console.error("Error updating status:", error);
        alert("Error updating status. Please try again.");
    } finally {
        setShowModal(false); 
    }
};

const cancelStatusChange = () => {
    setShowModal(false); 
};


  const renderTableRows = () => {
    const rows = [];
    let count = 0; // Counter to limit to 3 rows
    for (const key in data) {
      if (data[key] && data[key].serviceDetails && Array.isArray(data[key].serviceDetails)) {
        data[key].serviceDetails.forEach((service) => {
          if (count < 3) { // Only add the first 3 rows
            rows.push(
              <tr key={service.subId} className="border-gray-400 border-b-[1px]">
                <td className="text-center font-semibold text-[#2F3746] py-5">
                  <p>{service.subId}</p>
                </td>
                <td className="text-center text-[#8C90A6] py-5">
                  <p>{service.serviceName}</p>
                </td>
                <td className="text-center text-[#8C90A6] py-5">
                  <p>{data[key].categoryTitle}</p>
                </td>
                <td className="text-center text-[#8C90A6] py-5">
                  <p>{service.price}</p>
                </td>
                <td className="text-center text-[#8C90A6] py-5">
                  <p>{service.isBasicFare}</p>
                </td>
                <td className="text-center text-[#8C90A6] py-5">
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="hidden"
                      checked={service.servicestatus === "active"}
                      onChange={() => handleStatusChange(service.subId, service.servicestatus)}
                    />
                    <span
                      className={`relative inline-block w-10 h-6 transition-all duration-200 ease-in-out rounded-full ${service.servicestatus === "active"
                        ? "bg-[#2A668D]"
                        : "bg-gray-400"
                        }`}
                    >
                      <span
                        className={`absolute top-0 left-0 w-4 h-4 bg-white ml-1 mt-1 rounded-full transition-transform duration-200 ease-in-out ${service.servicestatus === "active"
                          ? "translate-x-4"
                          : ""
                          }`}></span>
                    </span>
                  </label>
                </td>
                <Link to={`/vendor/viewservice?id=${service.subId}`}>
                  <td className="text-center text-[#8C90A6] py-5">
                    <div className="flex justify-center cursor-pointer">
                      <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.1619 8.05262C13.1619 9.79862 11.7459 11.2136 9.99987 11.2136C8.25387 11.2136 6.83887 9.79862 6.83887 8.05262C6.83887 6.30562 8.25387 4.89062 9.99987 4.89062C11.7459 4.89062 13.1619 6.30562 13.1619 8.05262Z"
                          stroke="#B2B2B2"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.998 15.354C13.806 15.354 17.289 12.616 19.25 8.052C17.289 3.488 13.806 0.75 9.998 0.75H10.002C6.194 0.75 2.711 3.488 0.75 8.052C2.711 12.616 6.194 15.354 10.002 15.354H9.998Z"
                          stroke="#B2B2B2"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </td>
                </Link>
                <Link to={`/vendor/editservice?id=${service.subId}`}>
                  <td className="text-center text-[#8C90A6] py-5">
                    <div className="flex justify-center ml-[10px] cursor-pointer">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M14.4627 3.5372C14.9273 3.07258 15.8725 3.07258 16.3371 3.5372C16.8017 4.00183 16.8017 4.94698 16.3371 5.4116L6.8588 14.8899C6.72424 15.0245 6.50835 15.0657 6.3172 14.9803L3.07657 13.5602C2.88539 13.4749 2.76689 13.2644 2.78091 13.0469L3.15198 9.71689C3.1645 9.57226 3.21665 9.44033 3.29291 9.36599L12.7712 0.88868C13.2358 0.424056 14.1809 0.424056 14.6455 0.88868L14.4627 3.5372Z"
                          stroke="#B2B2B2"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </td>
                </Link>

              </tr>
            );
            count++; // Increment count for each row added
          }
        });
      }
    }
    return rows;
  };


  return (
    <>
      < div className="w-full  h-auto rounded-2xl lg:p-0">
        <div className="md:px-10 px-5 w-full mt-20 lg:mt-0">

          <div className="flex flex-col md:flex-row gap-4 mt-10">
            {/* <BookingBar />
            <OrderStatistics /> */}
            <Card/>
          </div>




          <div className="xl:w-full lg:w-[700px]">
            <div className="flex justify-between items-center lg:h-[100px]">
              <p className="text-[20px] text-[#27648B] font-[600]">
                Recent Bookings
              </p>
              <Link to={"/vendor/booking/"}>
                <button className="border-0 h-[30px] font-medium rounded-[4px] text-[#27648B]">
                  View All
                </button>
              </Link>
            </div>
            <div className="max-w-full xl:w-full lg:w-[700px] overflow-x-auto mb-10">
              <div className="max-w-full rounded-sm border-l-stroke border-r-stroke bg-white shadow-default dark:border-t-strokedark dark:bg-boxdark overflow-x-auto">
                <table className="w-full table-auto">
                  <thead>
                    <tr>
                      {bookingheaders.map((header, index) => (
                        <th
                          key={index}
                          className="border-t-[2px] border-b-[2px] py-5 xl:px-4 px-10 bg-[#F8F9FA] text-[14px] font-semibold text-[#2F3746]"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                       {recentLeadsData && Array.isArray(recentLeadsData) && recentLeadsData.slice(0,4).map((item, index) => (
                 
                                                                 <tr
                                                                     key={index}
                                                                     className="border-gray-400 border-b-[1px]"
                                                                 >
                                                                     <td className="text-center font-semibold text-[#2F3746] py-5">
                                                                         <p>{item.bookingId}</p>
                                                                     </td>
                                                                     <td className="text-center text-[#8C90A6] py-5">
                                                                         <p>{item.createdAt}</p>
                                                                     </td>
                                                                     <td className="text-center text-[#8C90A6] py-5">
                                                                         <p>{item.catograydetails?.categoryTitle}                                                        </p>
                                                                     </td>
                                                                     <td className="text-center text-[#8C90A6] py-5">
                                                                         <p>{item.userId}</p>
                                                                     </td>
                                                                     <td className="text-center text-[#8C90A6] py-5">
                                                                         <p>{item.selectedSlot.date},{item.selectedSlot.time}</p>
                                                                     </td>
                                                                     <td className="text-center text-[#8C90A6] py-5">
                                                        <p
                                                            className={`inline-flex rounded-[6px] py-1 px-8 text-sm font-medium ${
                                                                item.bookingstatus=== "Completed"
                                                                    ? "bg-[#ABD5B6] text-[#1A8537]"
                                                                    : item.bookingstatus=== "Cancelled"
                                                                    ? "bg-[#EB908D] text-[#85211A]"
                                                                    : item.bookingstatus === "Pending"
                                                                    ? "bg-[#f0cd8b] text-[#e4aa3d]"
                                                                    : "bg-[#c4dfcb] text-[#1A8537]"
                                                            }`}
                                                        >
                                                            {item.bookingstatus}
                                                        </p>
                                                    </td>
                                                                     <Link to={`/vendor/booking/Viewbooking?id=${item.bookingId}&email=${item.userId}&vendorId=${item.vendorId}`}>
                 
                                                                         <td className="text-center text-[#8C90A6] py-5">
                                                                             <div className="flex justify-center ml-[60px] cursor-pointer">
                                                                                 <svg
                                                                                     width="20"
                                                                                     height="17"
                                                                                     viewBox="0 0 20 17"
                                                                                     fill="none"
                                                                                     xmlns="http://www.w3.org/2000/svg"
                                                                                 >
                                                                                     <path
                                                                                         fillRule="evenodd"
                                                                                         clipRule="evenodd"
                                                                                         d="M13.1619 8.05262C13.1619 9.79862 11.7459 11.2136 9.99987 11.2136C8.25387 11.2136 6.83887 9.79862 6.83887 8.05262C6.83887 6.30562 8.25387 4.89062 9.99987 4.89062C11.7459 4.89062 13.1619 6.30562 13.1619 8.05262Z"
                                                                                         stroke="#B2B2B2"
                                                                                         strokeWidth="1.5"
                                                                                         strokeLinecap="round"
                                                                                         strokeLinejoin="round"
                                                                                     />
                                                                                     <path
                                                                                         fillRule="evenodd"
                                                                                         clipRule="evenodd"
                                                                                         d="M9.998 15.354C13.806 15.354 17.289 12.616 19.25 8.052C17.289 3.488 13.806 0.75 9.998 0.75H10.002C6.194 0.75 2.711 3.488 0.75 8.052C2.711 12.616 6.194 15.354 10.002 15.354H9.998Z"
                                                                                         stroke="#B2B2B2"
                                                                                         strokeWidth="1.5"
                                                                                         strokeLinecap="round"
                                                                                         strokeLinejoin="round"
                                                                                     />
                                                                                 </svg>
                                                                             </div>
                                                                         </td>
                                                                     </Link>
                                                                 </tr>
                                                             ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <div className="xl:w-full lg:w-[700px]">
            <div className="flex justify-between items-center lg:h-[100px]">
              <p className="text-[20px] text-[#27648B] font-[600]">
                Recent Services
              </p>
              <Link to={"/vendor/services"}>
                <button className="border-0 h-[30px] font-medium rounded-[4px] text-[#27648B]">
                  View All
                </button>
              </Link>
            </div>

            <div className="max-w-full overflow-x-auto h-auto min-h-screen mb-10 mt-5 lg:mt-4">
              <div className="max-w-full xl:w-full lg:w-[700px] rounded-sm border-l-stroke border-r-stroke bg-white shadow-default dark:border-t-strokedark dark:bg-boxdark overflow-x-auto">
                <table className="w-full table-auto">
                  <thead>
                    <tr>
                      {headers.map((header, index) => (
                        <th
                          key={index}
                          className="border-t-[2px] border-b-[2px] py-5 xl:px-4 px-10 bg-[#F8F9FA] text-[14px] font-semibold text-[#2F3746]"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {renderTableRows()}
                  </tbody>
                </table>
              </div>
              {showModal && (
                            <ConfirmationModal
                    message={`Are you sure you want to change the service status to ${currentService?.currentStatus === "active" ? "inactive" : "active"}?`}
                    onConfirm={confirmStatusChange}
                    onCancel={cancelStatusChange}
                />
            )}
            </div>
          </div>
        </div>




      </div>
    </>
  );
};
export default VendorDashboard;
